import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    Grid,
    useTheme,
    useMediaQuery,
    TextField,
    CircularProgress,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import { DateRange, AttachMoney } from '@mui/icons-material';
import axios from 'axios';
import { format, subDays } from 'date-fns';
import { playerCommissions } from '../../../Utils/services';

const PlayerCommissionDashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // const [loading, setLoading] = useState(false);
    const [loadSpinner, setLoadSpinner] = useState(false);
    const [error, setError] = useState(null);

    // State for filters
    const [dateRange, setDateRange] = useState({
        startDate: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd')
    });

    // State for player data
    const [players, setPlayers] = useState([]);


    // async function fetchSummaryData() {
    //     setLoadSpinner(true)
    //     setGraphLoading(true);
    //     let param = {
    //         start_date: dateRange.startDate,
    //         end_date: dateRange.endDate,
    //         group_by: groupBy
    //     }
    //     await viewCommissions(param).then((res) => {
    //         let tempres = res.body;
    //         setSummaryData(tempres.summary);

    //         setGraphData(tempres.graph);

    //         setLoadSpinner(false);
    //         setGraphLoading(false);
    //     }).catch(() => { setLoadSpinner(false); setGraphLoading(false); })
    // }


    // Fetch player commission data
    async function fetchPlayerCommissions() {
        setLoadSpinner(true)
        let param = {
            start_date: dateRange.startDate,
            end_date: dateRange.endDate
        }

        await playerCommissions(param).then((res) => {
            let tempres = res.body;

            console.log(tempres, "tempres");

            setPlayers(tempres);
            setLoadSpinner(false);
        }).catch(() => { setLoadSpinner(false); })

    };

    // Handle date range change
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Fetch data when filters change
    useEffect(() => {
        fetchPlayerCommissions();
    }, [dateRange]);

    return (
        <Box sx={{ p: isMobile ? 2 : 4 }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 4,
                flexDirection: isMobile ? 'column' : 'row',
                gap: 3
            }}>
                {/* <Typography variant="h4" component="h1" sx={{
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    fontSize: isMobile ? '1.8rem' : '2.2rem'
                }}>
                    Player Commissions
                </Typography> */}

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    width: isMobile ? '100%' : 'auto'
                }}>
                    <TextField
                        label="Start Date"
                        type="date"
                        name="startDate"
                        value={dateRange.startDate}
                        onChange={handleDateChange}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        sx={{ flex: 1 }}
                    />
                    <TextField
                        label="End Date"
                        type="date"
                        name="endDate"
                        value={dateRange.endDate}
                        onChange={handleDateChange}
                        InputLabelProps={{ shrink: true }}
                        size="small"
                        sx={{ flex: 1 }}
                    />
                </Box>
            </Box>

            {error && (
                <Box sx={{
                    backgroundColor: theme.palette.error.light,
                    p: 2,
                    borderRadius: 1,
                    mb: 3
                }}>
                    <Typography color="error">
                        {error}
                    </Typography>
                </Box>
            )}

            {loadSpinner ? (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px'
                }}>
                    <CircularProgress size={60} />
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {players.map((player) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={player.player_id}>
                            <Card sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: theme.shadows[6]
                                }
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    flexGrow: 1
                                }}>

                                    <Box
                                        component="img"
                                        src={player.player_photo}
                                        // alt={player.player_name}
                                        sx={{
                                            width: '100%',
                                            maxWidth: 240,
                                            height: 'auto',
                                            borderRadius: '8px',
                                        }}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = 'none';
                                        }}
                                    />


                                    <Typography variant="h6" sx={{ fontWeight: 600 }} mt={1}>
                                        {player.player_name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        {player.team_name}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    backgroundColor: theme.palette.grey[100],
                                    p: 2,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    borderTop: `1px solid ${theme.palette.divider}`
                                }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Transactions
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                            {player.total_transactions}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Commission
                                        </Typography>
                                        <Typography variant="h6" sx={{
                                            fontWeight: 700,
                                            color: theme.palette.success.main,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <AttachMoney fontSize="small" sx={{ mr: 0.5 }} />
                                            {player.total_commission_amount.toFixed(2)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default PlayerCommissionDashboard;